import React, { Component }  from 'react';
import { Modal } from 'antd';
import AdminForm from '../components/AdminForm';

export default class AdminAndUserModal extends Component {

  formRef = React.createRef(); 

  componentDidUpdate() {
    if (this.formRef.current && this.props.modalData.btnAction === 'AddBtn') {
      this.formRef.current.resetFields();
    }
  }

  handleFinish = () => {
      this.formRef.current
          .validateFields()
          .then((values) => {
            const adminRequest = {
                  ...values,
                  id: this.props.modalData.adminUserEdit.id, 
                };
                this.props.onSubmit(adminRequest);
          }).catch((info) => {
            console.log('驗證失敗:', info);
          });
  }

  render() {
    const { visible, onClose ,modalData ,errorMessage } = this.props;
    return (
        <Modal
            title={modalData.modalTitle}
            closable={false} 
            open={visible}
            onCancel={onClose}
            onOk={this.handleFinish}
        >
         <AdminForm form={this.formRef} modalData={modalData} errorMessage ={errorMessage} /> 
      </Modal>
    )
  }
}